<template>
    <!-- 斜体设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
    <div class="setting-item">
    <el-form-item label="是否斜体"> 
        <el-radio-group v-model="italic" size="small">
          <el-radio-button v-for="(item,index) in italicConfigList(value.type)"
                          :key="index" 
                          :label="item.label">{{item.value}}</el-radio-button>
        </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入斜体配置文件
import { italicConfigList } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 斜体
     *  @description 将 italic 字段映射到当前 italic 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      italic: { 
        parent: i => i.renderOption,
        attr: "italic" 
      }
    })
  },
  methods: {
    italicConfigList
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderItalic.vue